import React from "react";

import Sunset from "../components/Sunset";

import "../styles/Bio.css";

const Bio = () => {
    return (
        <div>
            <Sunset />
            <div className="text-box">
                <p className="bio-text">
                    Born in New Orleans, raised deep in bayou country and washed
                    up in the San Francisco Bay, Jeremy Jones, also known by the
                    stage name Professor Jones, is a singer-songwriter &
                    guitarist who delivers a signature "Swampedelic Rock & Soul"
                    sound that blends the mud of the Louisiana swamps with the
                    psychedelic sand of the California shore. His influences
                    include legendary artists such as Dr. John, the Meters,
                    Creedence Clearwater Revival, Jimi Hendrix, the Allman
                    Brothers Band & the Grateful Dead.
                </p>
                <br />
                <p className="bio-text">
                    Jones has released two full length albums. In his latest
                    release, Keep On Movin' (2015), he turns his attention to
                    his homeland to rediscover its rich musical heritage. The
                    album is a nod to some of his musical heroes from New
                    Orleans and the Deep South, and it showcases his versatility
                    as a songwriter and a guitarist. Keep On Movin' was recorded
                    at Light Rail Studios in San Francisco, and it boasts some
                    of the top musicians and studio engineers in California.
                    Jones' previous release, From Here On (2010), is an
                    all-acoustic concept album that features a 10-piece ensemble
                    playing a range of jazz and folk to orchestral and raga
                    music, and it is a stylistic nod to the late Nick Drake, one
                    of his biggest influences and musical inspirations at the
                    time.
                </p>
                <br />

                <p className="bio-text">
                    Music blogger Tyler Blue once wrote, "It's one thing just to
                    be a badass guitarist, the whole other to understand what it
                    takes to be a bandleader. Jones has what one might consider
                    360-degree vision in scanning the musical landscape around
                    him and knowing where to go next. The way in which he
                    structures his solos is a thing of beauty....He's got the
                    fundamentals wired along with an arsenal of tricks up his
                    sleeve. It's apparent he has processed a plethora of
                    influences into a signature style."
                </p>
            </div>
        </div>
    );
};

export default Bio;



// WEBPACK FOOTER //
// ./src/components/Bio.js